import textHeadingS from '@fukku/styles/texts/textHeadingS.module.css'
import { cx } from 'classix'
import { Channel } from 'types/masterData'
import { usePricesStore } from '../../context/PricesProvider'
import styles from './DiscountRate.module.css'

type DiscountRateProps = {
	readonly discountText?: string
}

export function DiscountRate({ discountText }: DiscountRateProps) {
	const {
		align = 'start',
		showDiscount = false,
		horizontal = false,
		showDiscountRate = true,
		priceClasses: { discountRate = textHeadingS.className },
		channel,
	} = usePricesStore()

	const shouldShowDiscount: boolean = showDiscount && Boolean(discountText)

	if (!shouldShowDiscount || !showDiscountRate) {
		return null
	}

	return (
		<div
			data-testid='discount-rate'
			className={cx(
				styles.discountRate,
				styles[align],
				channel === Channel.Outlet && styles.hightlightedDiscount,
				!horizontal && styles.vertical
			)}
		>
			<span className={discountRate}>{discountText}</span>
		</div>
	)
}
